export default __webpack_public_path__ + "static/conf-2017-f0c69a6cc2c49786ffc526ec20760e14.png";